import React from "react";

const LOGO_URL =
  "/natur-logo-inicio.png";

/**
 * Natur Autoescuela brand mark (transparent PNG — wide lockup).
 * Variants:
 *  - "header" → compact, fits in app headers
 *  - "card"   → medium, used in public confirmation page
 *  - "hero"   → big, used on login/auth screens
 */
export default function Logo({ variant = "header", className = "" }) {
  const heights = {
    header: "h-10 sm:h-12",
    card: "h-16 sm:h-20",
    hero: "h-24 sm:h-32",
  };
  return (
    <img
      src={LOGO_URL}
      alt="Natur Autoescuela"
      data-testid="brand-logo"
      draggable={false}
      className={"w-auto object-contain select-none " + heights[variant] + " " + className}
    />
  );
}
